// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.file-input {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.upload-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10px;
  border: 1px solid var(--ion-color-light-shade, #d7d8da);
  display: block;
}

.file-upload-container {
  position: relative;
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;
}

.thumbnail-wrap {
  position: relative;
}

.thumbnail-button {
  position: relative;
  display: block;
  width: 150px;
  height: 150px;
  padding: 0;
  border: 0;
  border-radius: 10px;
  background: transparent;
  color: inherit;
  cursor: pointer;
}

.thumbnail-button.preview-enabled {
  cursor: zoom-in;
}

.thumbnail-button:disabled {
  cursor: wait;
}

.thumbnail-button:focus-visible {
  outline: 3px solid color-mix(in srgb, var(--ion-color-primary, #3880ff) 45%, transparent);
  outline-offset: 3px;
}

.overlay {
  position: absolute;
  inset: 0;
  border-radius: 10px;
  background: rgba(15, 23, 42, 0.58);
  color: #fff;
  display: flex;
  gap: 0.4rem;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: opacity 220ms cubic-bezier(0.16, 1, 0.3, 1);
  font-size: 14px;
  font-weight: 600;
  pointer-events: none;
}

.overlay ion-icon {
  font-size: 1.2rem;
}

.thumbnail-button:hover .overlay,
.thumbnail-button:focus-visible .overlay,
.thumbnail-button.empty-image .overlay {
  opacity: 1;
}

.progress-bar-container {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 6px;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 0 0 10px 10px;
  overflow: hidden;
  pointer-events: none;
}

.progress-bar {
  height: 100%;
  background-color: var(--ion-color-success, #2dd36f);
  transition: width 0.2s ease;
}

.upload-status {
  position: absolute;
  inset: auto 0 0;
  padding: 0.35rem 0.5rem 0.55rem;
  color: #fff;
  background: linear-gradient(to top, rgba(15, 23, 42, 0.82), transparent);
  border-radius: 0 0 10px 10px;
  font-size: 0.75rem;
  font-weight: 600;
  text-align: center;
  pointer-events: none;
}

.clear-image-button {
  position: absolute;
  top: 0.35rem;
  right: 0.35rem;
  z-index: 1;
  margin: 0;
  --padding-start: 0.5rem;
  --padding-end: 0.5rem;
  --box-shadow: none;
  transition: transform 180ms cubic-bezier(0.16, 1, 0.3, 1);
}

.clear-image-button:active {
  transform: scale(0.96);
}

@media (prefers-reduced-motion: reduce) {
  .overlay,
  .progress-bar,
  .clear-image-button {
    transition: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/_components/file-upload/file-upload.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,uDAAA;EACA,cAAA;AACF;;AAEA;EACE,kBAAA;EACA,oBAAA;EACA,sBAAA;EACA,uBAAA;EACA,WAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,yFAAA;EACA,mBAAA;AACF;;AAEA;EACE,kBAAA;EACA,QAAA;EACA,mBAAA;EACA,kCAAA;EACA,WAAA;EACA,aAAA;EACA,WAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,uDAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;;;EAGE,UAAA;AACF;;AAEA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,oCAAA;EACA,4BAAA;EACA,gBAAA;EACA,oBAAA;AACF;;AAEA;EACE,YAAA;EACA,mDAAA;EACA,2BAAA;AACF;;AAEA;EACE,kBAAA;EACA,eAAA;EACA,+BAAA;EACA,WAAA;EACA,wEAAA;EACA,4BAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;AACF;;AAEA;EACE,kBAAA;EACA,YAAA;EACA,cAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,qBAAA;EACA,kBAAA;EACA,yDAAA;AACF;;AAEA;EACE,sBAAA;AACF;;AAEA;EACE;;;IAGE,gBAAA;EACF;AACF","sourcesContent":[".file-input {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n.upload-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 10px;\n  border: 1px solid var(--ion-color-light-shade, #d7d8da);\n  display: block;\n}\n\n.file-upload-container {\n  position: relative;\n  display: inline-flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.5rem;\n}\n\n.thumbnail-wrap {\n  position: relative;\n}\n\n.thumbnail-button {\n  position: relative;\n  display: block;\n  width: 150px;\n  height: 150px;\n  padding: 0;\n  border: 0;\n  border-radius: 10px;\n  background: transparent;\n  color: inherit;\n  cursor: pointer;\n}\n\n.thumbnail-button.preview-enabled {\n  cursor: zoom-in;\n}\n\n.thumbnail-button:disabled {\n  cursor: wait;\n}\n\n.thumbnail-button:focus-visible {\n  outline: 3px solid color-mix(in srgb, var(--ion-color-primary, #3880ff) 45%, transparent);\n  outline-offset: 3px;\n}\n\n.overlay {\n  position: absolute;\n  inset: 0;\n  border-radius: 10px;\n  background: rgba(15, 23, 42, 0.58);\n  color: #fff;\n  display: flex;\n  gap: 0.4rem;\n  justify-content: center;\n  align-items: center;\n  opacity: 0;\n  transition: opacity 220ms cubic-bezier(0.16, 1, 0.3, 1);\n  font-size: 14px;\n  font-weight: 600;\n  pointer-events: none;\n}\n\n.overlay ion-icon {\n  font-size: 1.2rem;\n}\n\n.thumbnail-button:hover .overlay,\n.thumbnail-button:focus-visible .overlay,\n.thumbnail-button.empty-image .overlay {\n  opacity: 1;\n}\n\n.progress-bar-container {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  height: 6px;\n  width: 100%;\n  background-color: rgba(0, 0, 0, 0.1);\n  border-radius: 0 0 10px 10px;\n  overflow: hidden;\n  pointer-events: none;\n}\n\n.progress-bar {\n  height: 100%;\n  background-color: var(--ion-color-success, #2dd36f);\n  transition: width 0.2s ease;\n}\n\n.upload-status {\n  position: absolute;\n  inset: auto 0 0;\n  padding: 0.35rem 0.5rem 0.55rem;\n  color: #fff;\n  background: linear-gradient(to top, rgba(15, 23, 42, 0.82), transparent);\n  border-radius: 0 0 10px 10px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-align: center;\n  pointer-events: none;\n}\n\n.clear-image-button {\n  position: absolute;\n  top: 0.35rem;\n  right: 0.35rem;\n  z-index: 1;\n  margin: 0;\n  --padding-start: 0.5rem;\n  --padding-end: 0.5rem;\n  --box-shadow: none;\n  transition: transform 180ms cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.clear-image-button:active {\n  transform: scale(0.96);\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .overlay,\n  .progress-bar,\n  .clear-image-button {\n    transition: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
